import React from 'react'
import PropTypes from 'prop-types'
import { Router } from 'react-router-dom'
import { CompatRouter } from 'react-router-dom-v5-compat'

import Routes from 'startup/common/routes'

const App = ({ history, store }) => {
  return (
    <Router history={history}>
      <CompatRouter>
        <Routes store={store} />
      </CompatRouter>
    </Router>
  )
}

App.displayName = 'App'

App.propTypes = {
  history: PropTypes.object,
  store: PropTypes.object,
}

export default App
